import React from 'react'
import { Container, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import { motion } from 'framer-motion'
import { ArrowRightIcon } from '../../assets/icons'
import { ScrollReveal } from '../transitions/ScrollReveal'
import { useI18n } from '../../i18n'

export const FAQ: React.FC = () => {
  const { t } = useI18n()

  return (
    <section id="faq" className="py-32 scroll-mt-20">
      <Container maxWidth="md">
        <ScrollReveal
          startProgress={0.55}
          endProgress={0.80}
          yOffset={12}
          className="text-center mb-16"
        >
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight">
            {t.faq.title}
          </h2>
        </ScrollReveal>

        <div className="space-y-3">
          {t.faq.questions.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <Accordion
                sx={{
                  background: 'rgba(20, 20, 20, 0.4)',
                  border: '1px solid rgba(255, 255, 255, 0.06)',
                  borderRadius: '12px !important',
                  mb: 2,
                  '&:before': {
                    display: 'none',
                  },
                  '&.Mui-expanded': {
                    margin: '0 0 12px 0',
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ArrowRightIcon className="w-5 h-5 text-gray-400 transform rotate-90" />
                  }
                  sx={{
                    '& .MuiAccordionSummary-content': {
                      my: 2,
                    },
                  }}
                >
                  <h3 className="font-medium text-white">
                    {faq.question}
                  </h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p className="text-gray-400 text-sm leading-relaxed">{faq.answer}</p>
                </AccordionDetails>
              </Accordion>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  )
}
